module.exports = __webpack_public_path__ + "assets/img/DynamicDeduction.4742d13b.png";